import TextCardBase from "./TextCardBase";
export default TextCardBase;